var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightpaginatioinarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41374 8.66374L2.16374 14.9137C1.98761 15.0899 1.74874 15.1888 1.49967 15.1888C1.2506 15.1888 1.01173 15.0899 0.83561 14.9137C0.65949 14.7376 0.560547 14.4987 0.560547 14.2497C0.560547 14.0006 0.65949 13.7617 0.83561 13.5856L6.42233 8.00045L0.837173 2.41374C0.749967 2.32653 0.680791 2.223 0.633596 2.10906C0.5864 1.99512 0.562109 1.873 0.562109 1.74967C0.562109 1.62635 0.5864 1.50422 0.633596 1.39028C0.680791 1.27634 0.749967 1.17282 0.837173 1.08561C0.924379 0.998405 1.02791 0.929229 1.14185 0.882034C1.25579 0.834838 1.37791 0.810547 1.50124 0.810547C1.62456 0.810547 1.74668 0.834838 1.86062 0.882034C1.97456 0.929229 2.07809 0.998405 2.1653 1.08561L8.4153 7.33561C8.50259 7.42281 8.57182 7.52638 8.619 7.6404C8.66619 7.75441 8.6904 7.87661 8.69026 8C8.69011 8.12339 8.66561 8.24553 8.61816 8.35943C8.57071 8.47333 8.50124 8.57674 8.41374 8.66374Z",
    fill: "#323E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightpaginatioinarrow);
export default __webpack_public_path__ + "static/media/right paginatioin arrow .643468576fc0196122ecf2c37adbe121.svg";
export { ForwardRef as ReactComponent };